"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M14 3a1.003 1.003 0 00-1.71-.71L4 10.59V6c0-.55-.45-1-1-1s-1 .45-1 1v7c0 .55.45 1 1 1h7c.55 0 1-.45 1-1s-.45-1-1-1H5.41l8.29-8.29c.19-.18.3-.43.3-.71z"];
//# sourceMappingURL=arrow-bottom-left.js.map